import React from "react";
import PrintContainer from "../components/PrintContainer";
import Header from "./Header";
import Kjosandi from "./kjosandi/Kjosandi";
import Kjorstjori from "./kjorstjori/Kjorstjori";
import Leidbeiningar from "./Leidbeiningar";
import "./a4.css";
import moment from "moment";

class FylgibrefToPrint extends React.Component {  

  render() {
    const { formState, kjosandi, activeKosning } = this.props;
    let timestamp = moment().format('DD.MM.YYYY H:mm');

    return (
      <PrintContainer>
        <Header kjosandi={kjosandi} activeKosning={activeKosning} />

        <Kjosandi kjosandi={kjosandi} activeKosning={activeKosning} timestamp={timestamp} />

        <Kjorstjori formState={formState} timestamp={timestamp} />
      </PrintContainer>
    );
  }
}

export default FylgibrefToPrint;